import { createContext } from 'react';

import { defaultDependencies } from './defaultDependencies';
/**
 * @deprecated This file is deprecated and will be removed in the future.
 * Use specific page dependency context or common dependencies from `common.ts`.
 */
export const DependenciesContext = createContext<Partial<typeof defaultDependencies>>(defaultDependencies);
